module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point3_4-3e33b25485c11f67ba7e16e0974dc238.jpg";